import React from "react";
import { exportData } from "../../services/exportService";

interface ExportButtonProps {
  filters: Record<string, any>;
  endpoint: string;
  filenamePrefix: string;
}

export const ExportButton: React.FC<ExportButtonProps> = ({
  filters,
  endpoint,
  filenamePrefix,
}) => {
  const handleExport = async () => {
    const hasAnyFilter = Object.values(filters).some(
      (value) =>
        (Array.isArray(value) && value.length > 0) ||
        (typeof value === "string" && value !== "") ||
        (typeof value === "number" && !isNaN(value))
    );

    const preparedFilters = hasAnyFilter
      ? {
          ...filters,
          creationTimeFrom: filters.creationTimeFrom
            ? new Date(filters.creationTimeFrom).toISOString()
            : undefined,
          creationTimeTo: filters.creationTimeTo
            ? new Date(filters.creationTimeTo).toISOString()
            : undefined,
          withdrawalTimeFrom: filters.withdrawalTimeFrom
            ? new Date(filters.withdrawalTimeFrom).toISOString()
            : undefined,
          withdrawalTimeTo: filters.withdrawalTimeTo
            ? new Date(filters.withdrawalTimeTo).toISOString()
            : undefined,
        }
      : {}; 

    try {
      await exportData(endpoint, preparedFilters, filenamePrefix);
    } catch (e) {
      console.error("❌ Export failed", e);
    }
  };

  return (
    <button
      onClick={handleExport}
      className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
    >
      Export CSV
    </button>
  );
};
